import * as React from "react";
import type { SVGProps } from "react";
const SvgIconStar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 23 22"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.93.01c-.42.07-.85.32-1.09.64-.07.1-.62 1.17-1.42 2.79L7.1 6.08l-2.9.44q-2.9.43-3.08.49c-.35.12-.71.42-.9.76-.16.29-.22.5-.22.84 0 .48.12.8.43 1.15.09.1 1.06 1.05 2.16 2.11 1.71 1.65 2 1.94 1.99 2L4.1 16.7c-.26 1.52-.48 2.87-.49 3-.04.67.34 1.32.96 1.63.22.1.38.15.66.17q.42.02.74-.11l2.67-1.4 2.55-1.35L13.73 20l2.68 1.4q.32.13.74.1c.46-.02.79-.17 1.12-.5q.54-.54.5-1.3c-.01-.14-.24-1.5-.5-3.03l-.49-2.78 2.13-2.12 2.13-2.12.1-.23c.15-.3.2-.5.2-.8 0-.28-.05-.5-.18-.76-.18-.38-.61-.75-1.02-.87-.1-.03-1.46-.24-3.02-.47l-2.84-.43-1.32-2.64C13.2 1.88 12.61.74 12.54.65c-.2-.26-.57-.51-.9-.6-.2-.05-.51-.07-.7-.04m-1 4.23L8.58 6.96c-.22.39-.61.68-1.03.78-.1.03-1.41.23-2.92.45-1.52.22-2.8.42-2.83.43-.07.02.04.13 1.96 1.98l2.16 2.1c.15.17.3.46.35.69.09.33.07.43-.45 3.48-.27 1.58-.48 2.89-.47 2.9l2.58-1.34c1.4-.74 2.64-1.38 2.74-1.41.16-.05.25-.07.53-.07s.37.02.53.07c.1.03 1.34.67 2.74 1.41 1.41.75 2.57 1.35 2.58 1.34s-.2-1.3-.47-2.86c-.36-2.1-.5-2.9-.5-3.06q0-.4.19-.77c.09-.2.15-.26 2.23-2.33 1.39-1.38 2.12-2.13 2.1-2.14l-2.81-.42-2.94-.44q-.41-.1-.78-.46l-.21-.22-.74-1.48-1.32-2.67-.6-1.18z"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconStar;
